export default {"src":"/_next/static/media/UI.70d998ad.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};